import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded, FuseAnimateGroup } from '@fuse';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button, Tab, Tabs, Icon, IconButton, Tooltip, Grid } from '@material-ui/core';
import ReactTable from "react-table";
import * as Actions from './store/actions';
import * as TableActions from 'main/components/tableSort/store/actions';
import _ from 'lodash';
import TableCellTooltip from '../../components/TableCellTooltip';
import GradebookSummary from './GradebookSummary';
import TabPanelButtons from '../../components/TabPanelButtons';

const styles = theme => ({
    layoutRoot   : {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot     : {
        height: 64,
        flex:   1,
    },
    tabRoot      : {
        height: 64
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
    },
    right: {
        'text-align': 'right'
    }
});

class Gradebook extends Component {
    state = {
        current_tab:       0,
        company_course_id: 0,
    }

    constructor(props) {
        super(props);

        const company_course_id = this.props.match.params.company_course_id;

        this.state = {
            ...this.state,
            company_course_id: company_course_id,
        }
    }

    componentDidMount = () => {
        this.props.getCourseEventList(this.state.company_course_id);
        this.props.getCourseStudentList(this.state.company_course_id);
    }

    handleEventRowClick = (event_info) => {
        this.props.history.push(`/grade/student/list/${event_info.company_calendar_event_id}`);
    }

    handleStudentRowClick = (student_info) => {
        this.props.history.push(`/gradebook/student/event_list/${this.state.company_course_id}/${student_info.student_id}`);
    }

    getPageContent = (current_tab) => {
        const { courseEventList, courseStudentList, table_sort, table_filter, table_page_size, is_loaded } = this.props;
        
        if (!is_loaded) return <React.Fragment>Loading...</React.Fragment>;

        switch(current_tab)
        {
            case(0): // Event list
            {
                const table_name = 'GradebookEventList';

                return (
                    <ReactTable
                        style={{ position: 'absolute' }}
                        columns={[
                            {
                                Header: "Lesson Name",
                                accessor: "LessonName",
                                Cell: row => (
                                    <TableCellTooltip
                                        item={row.original.LessonName}
                                        chars={20}
                                    />
                                )
                                
                            },
                            {
                                Header: "Event Type",
                                accessor: "EventType",
                            },
                            {
                                Header: "Event Name",
                                accessor: "EventName",
                                Cell: row => (
                                    <TableCellTooltip
                                        item={row.original.EventName}
                                        chars={20}
                                    />
                                )
                            },
                            {
                                Header: "Event Date",
                                accessor: "EventDate"
                            },
                            {
                                id: 'EventIsGradable',
                                Header: "Is Gradable Event",
                                maxWidth: 150,
                                accessor: row => row.EventIsGradable ? 'Yes' : 'No',
                            },
                            {
                                id: 'EventIsRequired',
                                Header: "Is Required to Pass",
                                maxWidth: 150,
                                accessor: row => row.EventIsRequired ? 'Yes' : 'No',
                            },
                            {
                                Header: "Grade",
                                maxWidth: 100,
                                Cell: (row) => (
                                    <Tooltip title="View Course Gradebook">
                                        <IconButton
                                            style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                            onClick={(ev) => {
                                                ev.stopPropagation();
                                                this.handleEventRowClick(row.original);
                                            }}
                                        >
                                            <Icon>assignment</Icon>
                                        </IconButton>
                                    </Tooltip>
                                )
                            }
                        ]}
                        data={courseEventList}
                        defaultPageSize={25}
                        pageSize={table_page_size[table_name]}
                        className="-striped -highlight"
                        noDataText="No Events Found"
                        defaultSorted={table_sort[table_name]}
                        onSortedChange={(sort_list) => this.props.setTableSort(this.props.auth.user.data.auth_id, table_name, sort_list)}
                        filterable={true}
                        defaultFiltered={table_filter[table_name]}
                        onFilteredChange={_.debounce((filter_list) => this.props.setTableFilter(this.props.auth.user.data.auth_id, table_name, filter_list), 500)}
                        onPageSizeChange={(page_size) => this.props.setTablePageSize(this.props.auth.user.data.auth_id, table_name, page_size)}
                    />
                );

            }

            case(1): // Student List
            {
                const table_name = 'GradebookStudentList';
                
                return (
                    <ReactTable
                        style={{ position: 'absolute' }}
                        columns={[
                            {
                                Header: "First Name",
                                accessor: "FirstName"
                            },
                            {
                                Header: "Last Name",
                                accessor: "LastName"
                            },
                            {
                                Header: "Course Status",
                                accessor: 'status'
                                // Cell: (row) => (
                                //     row.original.finished ? 'Finished' : 'In Progress'
                                // )
                            },
                            {
                                Header: "",
                                Cell: (row) => (
                                    <IconButton
                                    style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                        onClick={(ev) => {
                                            ev.stopPropagation();
                                            this.handleStudentRowClick(row.original);
                                        }}
                                    >
                                        <Icon>assignment</Icon>
                                    </IconButton>
                                )
                            }
                        ]}
                        data={courseStudentList}
                        defaultPageSize={25}
                        pageSize={table_page_size[table_name]}
                        className="-striped -highlight"
                        noDataText="No Events Found"
                        defaultSorted={table_sort[table_name]}
                        onSortedChange={(sort_list) => this.props.setTableSort(this.props.auth.user.data.auth_id, table_name, sort_list)}
                        filterable={true}
                        defaultFiltered={table_filter[table_name]}
                        onFilteredChange={_.debounce((filter_list) => this.props.setTableFilter(this.props.auth.user.data.auth_id, table_name, filter_list), 500)}
                        onPageSizeChange={(page_size) => this.props.setTablePageSize(this.props.auth.user.data.auth_id, table_name, page_size)}
                    />
                );
            }
            
            case(2): // Summary
            {
                return <GradebookSummary calendar_course_id={this.state.company_course_id} />
            }

            default:
            {
                return <React.Fragment>Error: No tab found.</React.Fragment>
            }
        }
    }

    handleChangeTab = (event, value) => {
        this.setState({
            ...this.state,
            current_tab: value
        });
    }

    render() {
        const { classes, course_name, auth } = this.props;
        const { current_tab }                = this.state;
        const page_content                   = this.getPageContent(current_tab);

        return (
            <FusePageCarded
                classes={{
                    root:    classes.layoutRoot,
                    toolbar: classes.layoutToolbar
                }}
                header={
                    <div className="py-24">
                        <h4>
                            { "Gradebook" }
                        </h4>
                        <h4>
                            Course Name: {course_name}
                        </h4>
                    </div>
                }
                contentToolbar={
                    <div style={{ width: '100%', height: '100%' }}>
                        <Grid container>
                            <Tabs
                                value={current_tab}
                                onChange={this.handleChangeTab}
                                indicatorColor="primary"
                                textColor="primary"
                                classes={{
                                    root: classes.tabsRoot
                                }}
                            >
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Event List"
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Student List"
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Summary"
                                />
                            </Tabs>
                            <TabPanelButtons
                                component_name={"gradebook"}
                                view_type={'detail'}
                                button_list={[
                                    {
                                        type: "back",
                                        onClick: () => this.props.history.goBack(),
                                    }
                                ]}
                            />
                        </ Grid>
                    </div>
                }
                content={page_content}
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getCourseEventList:   Actions.getCourseEventList,
        getCourseStudentList: Actions.getCourseStudentList,
        setTableSort:         TableActions.setTableSort,
        setTableFilter:       TableActions.setTableFilter,
        setTablePageSize:     TableActions.setTablePageSize,
    }, dispatch);
}

function mapStateToProps({ gradebookApp, tableSort, auth }) {
    return {
        courseEventList:   gradebookApp.gradebook.courseEventList,
        courseStudentList: gradebookApp.gradebook.courseStudentList,
        course_name:       gradebookApp.gradebook.course_name,
        table_sort:        tableSort.table_sort,
        table_filter:      tableSort.table_filter,
        table_page_size:   tableSort.table_page_size,
        is_loaded:         tableSort.is_loaded,
        auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Gradebook)));


// WEBPACK FOOTER //
// src/main/content/gradebook/Gradebook.js